function ClearanceItems() {
  return (
    <div className='hidden justify-center'>
      We have Clearance Items For Sale Display whatever slabs we want to sell
      quick
    </div>
  )
}

export default ClearanceItems
